import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';


@Component({
  selector: 'not-found-exception-page',
  templateUrl: './not-found-exception-page.component.html',
  styleUrls: ['./not-found-exception-page.component.css']
})
export class NotFoundExceptionPageComponent implements OnInit {

  constructor(private _titleService:Title) { }


  ngOnInit() {
	this._titleService.setTitle("Page not exists!");
  }

}
